module.exports = __webpack_public_path__ + "static/media/qz.com_762868_giving-up-alcohol-opened-my-eyes-to-the-infuriating-truth-about-why-women-drink__plot.1ecd57af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/qz.com_762868_giving-up-alcohol-opened-my-eyes-to-the-infuriating-truth-about-why-women-drink__plot.png
// module id = 421
// module chunks = 0